import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      gsap.registerPlugin( ScrollTrigger );
      let navHeight = $( '.navbar' ).outerHeight();
      let triggerPos = 0;

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      triggerPos += navHeight;

      const height = $( '.tenant-directory' ).outerHeight();

      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.tenant-directory',
          start: 'top ' + triggerPos,
          end: '=+' + height,
          scrub: 0,
          pin: '.tenant-jump-links',
          pinSpacing: false,
        },
      } );

      // Change active letter in jump link nav
      const letterChangers = gsap.utils.toArray( '.letter-changed' );
      let i = 0;
      letterChangers.forEach( ( val ) => {
        const thisPos = $( val ).offset().top;
        let posDiff;

        if ( $( '.letter-changed' )[i + 1] ) {
          const nextPos = $( $( '.letter-changed' )[i + 1] ).offset().top;
          posDiff = nextPos - thisPos;
        } else {
          posDiff = $( val ).outerHeight();
        }

        gsap.from( val, {
          scrollTrigger: {
            trigger: val,
            start: 'top ' + triggerPos,
            end: '=+' + posDiff,
            scrub: 0,
            toggleClass: {
              targets: $( '.tenant-jump-links a[href="#' + $( val ).attr( 'id' ) + '"]' )[0],
              className: 'is-active',
            },
          },
        } );
        i++;
      } );

      $( '.tenant-jump-links a' ).click( function() {
        if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
          let target = $( this.hash );
          let wpadminBarHeight = 0;
          if ( $( '#wpadminbar' ).length > 0 ) {
            wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
          }
          const headerHeight = $( 'header.navbar' ).outerHeight();
          target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );
          if ( target.length ) {
            $( 'html, body' ).animate( {
              scrollTop: target.offset().top - ( headerHeight + wpadminBarHeight + $( '.tenant-jump-links' ).outerHeight() - 15 ),
            }, 1000 );
            return false;
          }
        }
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'tenant', COMPONENT );
} )( app );
